<template>

    <div class="sticky-header-wrapper">
        <Header :title="'Хэштеги'" />
    </div>


    <div class="hashtags-page">

            <!-- Белое облачко -->
        <div class="profile-container">
        <div class="info-block-other">
            <Hashtags :initialHashtags="myHashtags" />
        </div>
        </div>

    </div>

    <div class="sticky-footer-wrapper">
        <MiniFooter />
    </div>

  </template>
  
  <script setup>
import { onMounted, ref } from 'vue'
import Header from '../components/ProfileHeader.vue'
import MiniFooter from '../components/MiniFooter.vue'
import Hashtags from '../components/HashtagsForProfile.vue'
import UserService from '../api/UserService.js'

const myHashtags = ref([])

onMounted(async () => {
  const userId = localStorage.getItem('user_id')
  if (!userId) return

  try {
    const response = await UserService.getMyHashtags(userId)

    console.log('📦 Server full response:', response) // ← response.data!
    if (Array.isArray(response.hashtags)) {
  myHashtags.value = response.hashtags;
  console.log("✅ Получены хэштеги:", myHashtags.value);
}
  } catch (err) {
    console.error('❌ Ошибка при получении хэштегов:', err)
  }
})

</script>
  
<style scoped>

.hashtags-page {
  background-color: var(--profile_background-color);
  height: 100vh; /* 🧱 фиксируем высоту экрана */
  overflow: hidden; /* ⛔ блокируем прокрутку */
  padding-top: 200px;
}

.sticky-header-wrapper {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: var(--profile_header-bg);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}
.profile-container {
  height: 600px;
  position: fixed; /* 👈 фиксируем на экране */
  top: 100px;       /* отступ от хедера */
  left: 50%;
  transform: translateX(-50%);
  max-width: 900px;
  width: 90%;
  background-color: var(--profile_container-color);
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  z-index: 10;
}

.info-block-other {
  padding: 30px;
}

.placeholder-text {
  font-family: "Eastman-Regular", sans-serif;
  font-size: 16px;
  color: var(--profile_text-color);
}

.placeholder-text {
  font-family: "Eastman-Regular", sans-serif;
  font-size: 16px;
  color: var(--profile_text-color);
}

.sticky-footer-wrapper {
  position: sticky;
  bottom: 0;
  z-index: 90;
  background-color: var(--profile_footer-bg);
  box-shadow: 0 -1px 4px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

  </style>